var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton, styled, Switch, useTheme } from "@mui/material";
import VTTextField from "./VTTextField";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { forwardRef, useEffect, useState } from "react";
import textCutOffAddElipsis from "../utils/textCutOffAddElipsis";
var StyledTableCellRow = styled(TableCell)(function (_a) {
    var theme = _a.theme;
    return ({
        border: "none",
        background: "#555",
    });
});
var VTMarksDataEntryTable = forwardRef(function (_a, ref) {
    var sx = _a.sx, tableData = _a.tableData, _b = _a.hotspotNameCharCutOffPoint, hotspotNameCharCutOffPoint = _b === void 0 ? 50 : _b, onDataChanged = _a.onDataChanged, onHotspotNameClicked = _a.onHotspotNameClicked;
    var theme = useTheme();
    // let columnNames = Object.keys(tableData[0]);
    var _c = __read(useState(tableData), 2), marksTableData = _c[0], setMarksTableData = _c[1];
    useEffect(function () {
        setMarksTableData(tableData);
    }, [tableData]);
    useEffect(function () {
        onDataChanged(marksTableData);
    }, [marksTableData]);
    return (_jsx(TableContainer, __assign({ ref: ref, sx: __assign({ borderRadius: "20px" }, sx) }, { children: _jsxs(Table, __assign({ sx: { borderCollapse: "separate", borderSpacing: "2px" } }, { children: [_jsx(TableHead, __assign({ sx: { background: theme.palette.primary.light } }, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: " Hotspot Name " }), _jsx(TableCell, { children: " Marked " }), _jsx(TableCell, { children: " Correct " }), _jsx(TableCell, { children: " Weighting " })] }) })), _jsx(TableBody, { children: marksTableData.map(function (row, i) {
                        return (_jsxs(TableRow, __assign({ sx: {} }, { children: [_jsx(StyledTableCellRow, __assign({ onClick: function () {
                                        onHotspotNameClicked && onHotspotNameClicked(row.hotspotName);
                                    }, sx: {
                                        "&:hover": __assign({}, (onHotspotNameClicked && {
                                            background: "#777",
                                            color: !row.marked ? "#bbb" : "inherit",
                                            cursor: "pointer",
                                        })),
                                        padding: "5px",
                                        paddingLeft: "15px",
                                        color: !row.marked ? "#999" : "inherit",
                                    }, component: "th", scope: "row" }, { children: textCutOffAddElipsis(row.hotspotName, hotspotNameCharCutOffPoint) })), _jsx(StyledTableCellRow, __assign({ sx: { padding: "5px", width: "10px", textAlign: "center" }, component: "th", scope: "row" }, { children: _jsx(Switch, { checked: row.marked, onChange: function () {
                                            var marksTableDataCopy = __spreadArray([], __read(marksTableData), false);
                                            if (row.marked) {
                                                marksTableDataCopy[i].marked = false;
                                            }
                                            else {
                                                marksTableDataCopy[i].marked = true;
                                            }
                                            setMarksTableData(marksTableDataCopy);
                                        } }) })), _jsx(StyledTableCellRow, __assign({ align: "center", sx: { padding: "5px", width: "5px" }, component: "th", scope: "row" }, { children: row.correct ? (_jsx(IconButton, __assign({ sx: {
                                            background: "#00cc66",
                                            "&:hover": { background: "#00cc66" },
                                            "&.Mui-disabled": { background: "#00cc66", opacity: 0.5 },
                                        }, disabled: !row.marked, onClick: function () {
                                            var marksTableDataCopy = __spreadArray([], __read(marksTableData), false);
                                            marksTableDataCopy[i].correct = false;
                                            setMarksTableData(marksTableDataCopy);
                                        } }, { children: _jsx(DoneRoundedIcon, {}) }))) : (_jsx(IconButton, __assign({ sx: {
                                            background: "#cc0000",
                                            "&:hover": { background: "#cc0000" },
                                            "&.Mui-disabled": { background: "#cc0000", opacity: 0.5 },
                                        }, disabled: !row.marked, onClick: function () {
                                            var marksTableDataCopy = __spreadArray([], __read(marksTableData), false);
                                            marksTableDataCopy[i].correct = true;
                                            setMarksTableData(marksTableDataCopy);
                                        } }, { children: _jsx(CloseRoundedIcon, {}) }))) })), _jsx(StyledTableCellRow, __assign({ sx: { padding: "5px", width: "5px" }, component: "th", scope: "row" }, { children: _jsx(VTTextField, { disabled: !row.marked, sx: { width: "100px" }, type: "number", value: String(row.weighting), onChange: function (val) {
                                            var marksTableDataCopy = __spreadArray([], __read(marksTableData), false);
                                            marksTableDataCopy[i].weighting = Number(val);
                                            setMarksTableData(marksTableDataCopy);
                                        } }) }))] }), i));
                    }) })] })) })));
});
export { VTMarksDataEntryTable };
